<template>
    <div class="newsletter" :class="{ 'loading' : loading }">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <h4 class="newsletter__title">{{ $root.t('Fique por dentro de tudo!') }}</h4>
                    <p class="newsletter__description">{{ $root.t('Saiba em primeira mão sobre o lançamento dos nossos treinos e a programação de todas nossas lives') }}</p>

                    <form action="" @submit.prevent="submit" v-if="status == ''">
                        <input @blur.once="gaInputBlur" type="text" v-model="form.name" id="name" name="name" :placeholder="$root.t('Seu nome')" required>
                        <input @blur.once="gaInputBlur" type="text" v-model="form.email" id="email" name="email" :placeholder="$root.t('Seu e-mail')" required>
                        <button type="submit" :value="$root.t('Quero ficar por dentro!')" :disabled="!checked">{{ $root.t('Quero ficar por dentro!') }}</button>
                    </form>
                    <div class="newsletter__message" v-else>
                        <p>{{ $root.t(status) }}</p>
                    </div>
                    <input id="agree" type="checkbox" value="agree" v-model="checked"/>
                        <label for="agree" class="checkbox">{{ $root.t('Ao aceitar o recebimento das novidades você automaticamente aceita os') }}
                            <a :href="require(`@/assets/terms/termos-${locale}.pdf`)" target="_blank">{{ $root.t('Termos de Uso') }}</a>
                        </label>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { fallback_country } from "@/fallbacks";

export default {
    data () {
        return {
            status : '',
            loading : false,
            checked : false,
            form : {
                name : '',
                email : '',
                country : fallback_country
            }
        }
    },
    computed: {
        ...mapGetters(['theme', 'locale'])
    },
    methods : {
        submit() {
            this.loading = true;


            //Safety Mail
            const sm_ticket_origem = '0610f4628ffb76ea66939519618b15768de39872';
            const sm_api_key = '88a9fa5c91f3394bae0a8cf7d557fb2a25f6aa44';
            const sm_main_url = 'https://optin.safetymails.com/main';
            const sm_command = 'safetyoptin';
            const sm_email_b64 = btoa(this.form.email);
            const sm_api_url = `${sm_main_url}/${sm_command}/${sm_api_key}/${sm_ticket_origem}/${sm_email_b64}`;

            axios.post(sm_api_url)
                .then( res => {
                    console.log(res.data)
                    if(res.data.StatusCal == 'OK'){
                        switch(res.data.StatusEmail){
                            case 'VALIDO':
                            case 'INCERTO':
                            case 'SCRAPED':
                            case 'PENDENTE':
                                axios.post(`https://treineemcasa.bioritmo.io/index.php?rest_route=/smart/v1/newsletter`, this.form)
                                .then( () => {
                                    this.status = 'Sucesso! Em breve você receberá avisos sobre novas lives'
                                    this.loading = false
                                    document.querySelector('.safetyoptin-result').remove();
                                    this.gaFormSubmit()
                                })
                                .catch( err => {
                                    //this.status = 'Ops, algo deu errado, tente novamente dentro de alguns minutos'
                                    this.status = err.response.data.message;
                                    this.loading = false;
                                    document.querySelector('.safetyoptin-result').remove();
                                })
                            break;
                            default:
                                this.status = 'Por favor, verifique se o email foi preenchido corretamente'
                                this.loading = false
                                setTimeout(()=>{
                                    this.status = '';
                                },5000)
                            break;
                        }
                    } else {
                        this.status = 'Ops, algo deu errado, tente novamente dentro de alguns minutos'
                        this.loading = false
                    }
                })

            return false
        },
        gaInputBlur(event) {
            this.$gtm.trackEvent({
                event: 'gaEvent',
                eventCategory: `treine-em-casa-${this.theme}`,
                eventAction: `preenchimento-${event.target.name}`,
                eventLabel: '',
            });
        },
        gaFormSubmit() {
            this.$gtm.trackEvent({
                eventCategory: `treine-em-casa-${this.theme}`,
                event: 'gaEvent',
                eventAction: 'newsletter-sucesso',
                eventLabel: ''
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";

    .newsletter {
        padding: 60px 20px;
        text-align: center;
        font-size: 16px;
        background: #17181A;
        transition: all .6s;
        margin: 0 0 40px;

        &.loading {
            opacity: 0.5;
            pointer-events: none;
        }

        &__title {
            font-size: 22px;
        }

        &__description {
            color: #808080;
            margin-top: 0;
        }

        &__message {
            color: white;
        }

        input {
            border-radius: 5px;
            background-color: transparent;
            border: 1px solid #404040;
            color: white;
            padding: 10px 20px;
            margin: 0 10px 10px 10px;
            transition: all .6s;

            @media screen and (max-width: 768px) {
                width: calc(100% - 20px);
            }

            &:active, &:focus {
                background: rgba(255, 255, 255, 0.1);
                border-color: white;
            }
        }

        button[type=submit] {
            background: $c_primary;
            border-radius: 5px;
            border: 0;
            margin-bottom: 20px;
            padding: 10px 20px;
            text-transform: uppercase;
            color: black;
            font-weight: 500;
            cursor: pointer;

            &:disabled {
                opacity: .3;
            }
        }

        input[type="checkbox"] {
            position: absolute;
            opacity: 0;
            z-index: -1;
        }

        label.checkbox {
            position: relative;
            display: inline-block;
            padding: 0 0 0 2em;
            height: 1.6em;
            line-height: 1.6;
            cursor: pointer;
            color: #808080;
            text-align: left;

            &::before,
            &::after {
                position: absolute;
                top: 10px;
                left: 0;
                display: block;
                width: 1.3em;
                height: 1.3em;
            }

            &::before {
                content: " ";
                border: 1px solid #808080;
                border-radius: 20%;
            }

            @media (min-width: 576px) {
                text-align: center;
                line-height: 2.6;
            }

        }

        input[type="checkbox"] + label::after {
            content: "\2714";
            color: #2c3e50;
            line-height: 1.5;
            text-align: center;
        }

        input[type="checkbox"]:checked + label::before {
            background: #fff;
            border-color: #fff;
        }

        input[type="checkbox"] + label::after {
            -webkit-transform: scale(0);
            -ms-transform: scale(0);
            -o-transform: scale(0);
            transform: scale(0);
        }

        input[type="checkbox"]:checked + label::after {
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
            -o-transform: scale(1);
            transform: scale(1);
        }

        label::before,
        label::after {
            -webkit-transition: .25s all ease;
            -o-transition: .25s all ease;
            transition: .25s all ease;
        }
        

    }
</style>
